module.exports = __webpack_public_path__ + "static/media/logo2.e3f4f62d.png";